import {
  getIconForKpiType,
  KpiType,
} from 'fabscale-app/models/enums/kpi-types';

export default function kpiTypeIcon(kpiType: KpiType): string {
  return getIconForKpiType(kpiType) || 'chart-line';
}
